import {gql} from '@apollo/client'
import {productThumbnailFragment} from '../Products/queries'

export const collectionsQuery = gql`
  ${productThumbnailFragment}
  query Collections($first: Int, $filter: CollectionFilterInput) {
    collections(first: $first, filter: $filter) {
      edges {
        node {
          id
          slug
          name
          description
          backgroundImage {
            url
            alt
          }
          products(first: 20) {
            edges {
              node {
                ...ProductThumbnailFields
              }
            }
          }
        }
      }
    }
  }
`
